export function editorAPI()
{
    const ctx = (typeof window !== 'undefined' ? window : global) as any as { tinymce: any; hugerte: any };

    return ctx && ctx.tinymce ? ctx.tinymce : ctx.hugerte ? ctx.hugerte : null;
}
